export default __webpack_public_path__ + "static/media/es_icon.50568d21.png";